"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTypeEnum = void 0;
var AuthTypeEnum;
(function (AuthTypeEnum) {
    AuthTypeEnum[AuthTypeEnum["Phone"] = 1] = "Phone";
})(AuthTypeEnum || (exports.AuthTypeEnum = AuthTypeEnum = {}));
//# sourceMappingURL=AuthTypeEnum.js.map